import { Box, Dialog, DialogContent, DialogTitle, Divider, IconButton, List, ListItem, ListItemButton, ListItemText, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { Board, Notice } from "../type";
import { Event } from "../type";
import React from "react";

interface ContentSelectorDialogProps {
  open: boolean;
  onClose: () => void;
  onSelect: (content: any) => void;
  events: Event[];
  notices: Notice[];
  boards: Board[];
}

const ContentSelectorDialog = ({ open, onClose, onSelect, events, notices, boards }: ContentSelectorDialogProps) => {

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <Typography variant="h6">연결화면 선택</Typography>
                <IconButton onClick={onClose} size="small">
                    <CloseIcon />
                </IconButton>
            </Box>
        </DialogTitle>
        <DialogContent dividers>
        <Box sx={{ display: 'flex', gap: 4 }}>
            {/* 고정 화면 목록 (홈, 프로필 등) */}
            <Box sx={{ flex: 1 }}>
            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                고정 화면
            </Typography>
            <List>
                <ListItem disablePadding>
                <ListItemButton onClick={() => onSelect({ type: 'home', content: '홈 화면' })}>
                    <ListItemText primary="홈 화면" secondary="home" />
                </ListItemButton>
                </ListItem>
                {/* <Divider />
                <ListItem disablePadding>
                <ListItemButton onClick={() => onSelect({ type: 'profile', content: '프로필 화면' })}>
                    <ListItemText primary="프로필 화면" secondary="profile" />
                </ListItemButton>
                </ListItem> */}
            </List>
            </Box>

            {/* 이벤트 목록 */}
            <Box sx={{ flex: 1 }}>
                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                이벤트
                </Typography>
                <List>
                {events.map((doc, index) => (
                    <React.Fragment key={doc.eventId}>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => onSelect({ type: 'event', id: doc.eventId, title: doc.title, content: doc.content })}>
                                <ListItemText
                                    primary={doc.title || doc.content}
                                    secondary={doc.eventId}
                                />
                            </ListItemButton>
                        </ListItem>
                        {index < events.length - 1 && <Divider />}
                    </React.Fragment>
                ))}
                </List>
            </Box>

            {/* 공지사항 목록 */}
            <Box sx={{ flex: 1 }}>
                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                공지사항
                </Typography>
                <List>
                {notices.map((doc, index) => (
                    <React.Fragment key={doc.noticeId}>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => onSelect({ type: 'notice', id: doc.noticeId, title: doc.title, content: doc.content })}>
                                <ListItemText
                                    primary={doc.title || doc.content}
                                    secondary={doc.noticeId}
                                />
                            </ListItemButton>
                        </ListItem>
                        {index < notices.length - 1 && <Divider />}
                    </React.Fragment>
                ))}
                </List>
            </Box>


            {/* 게시물 목록 */}
            {/* <Box sx={{ flex: 1 }}>
                <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                게시물
                </Typography>
                <List>
                {boards.map((doc, index) => (
                    <React.Fragment key={doc.boardId}>
                        <ListItem disablePadding>
                            <ListItemButton onClick={() => onSelect({ type: 'board', id: doc.boardId, title: doc.title, content: doc.content })}>
                                <ListItemText
                                    primary={doc.title || doc.content}
                                    secondary={doc.boardId}
                                />
                            </ListItemButton>
                        </ListItem>
                        {index < boards.length - 1 && <Divider />}
                    </React.Fragment>
                ))}
                </List>
            </Box> */}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ContentSelectorDialog;